import React from 'react';
import { useModalStore } from '@/store/modalStore';
import { Modal } from '@/components/ui/common/modal/Modal';
import { SessionTakeoverModal } from '@/components/auth/SessionTakeoverModal';

export const GlobalModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentModal, hideModal } = useModalStore();

  return (
    <>
      {children}
      <SessionTakeoverModal />
      {currentModal && (
        <Modal
          key={currentModal.id}
          isVisible={true}
          title={currentModal.title}
          message={currentModal.message}
          onConfirm={currentModal.onConfirm}
          onCancel={currentModal.onCancel}
          onClose={hideModal}
          confirmText={currentModal.confirmText}
          cancelText={currentModal.cancelText}
          variant={currentModal.variant}
          showCancel={currentModal.showCancel}
          confirmKeyword={currentModal.confirmKeyword}
          confirmPrompt={currentModal.confirmPrompt}
        />
      )}
    </>
  );
};
